import { ReduxState } from '../../../redux/types';

import { selectActiveStakes } from './state';


export const selectAutoUpdate = (state: ReduxState) => {
  return selectActiveStakes(state).autoUpdate;
};
